import React from 'react';
import { AutocompleteViewModel } from './autocomplete.view-model';

const AutocompleteContext = React.createContext<AutocompleteViewModel<any> | undefined>(
  undefined
);

export const AutocompleteProvider = ({
  viewModel,
  children,
}: {
  viewModel: AutocompleteViewModel<any>;
  children: React.ReactNode;
}) => {
  return (
    <AutocompleteContext.Provider value={viewModel}>
      {children}
    </AutocompleteContext.Provider>
  );
};


export const useAutocomplete = () => {
  const ctx = React.useContext(AutocompleteContext);
  if (!ctx) {
    throw new Error('useAutocomplete must be used inside AutocompleteProvider');
  }
  return ctx;
};
